import React, { Component } from 'react'
import Modal from 'react-modal'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import ProjectListPageUI from './ProjectListPageUI.js'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils';

class ProjectListPageSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            messageList: null,
            projectList: null,
            filteredProjectList: null,
            // filters
            searchFilter: '',
            //
            successMsg: null,
            errorList: null,
            createMode: false,
            updateMode: false,
            deleteMode: false,
            submitted: false,
            selectedCount: 0,
            //
            projectName: '',
            projectNameError: null,
            // contact attributes
            firstName: '',
            lastName: '',
            firstNameError: null,
            lastNameError: null,
            // phoneNumber attributes
            phoneNumber: null,
            phoneNumberError: null,
            // email attributes
            email: '',
            emailError: null,
            //
            selectedProjectId: null
        }
    }

    render() {
        return (
            <ProjectListPageUI
                context={this.props.context}
                messageList={this.state.messageList}
                projectList={this.state.projectList}
                filteredProjectList={this.state.filteredProjectList}
                // filters
                searchFilter={this.state.searchFilter}
                onSearchFilterChange={this.onSearchFilterChange}
                // form
                successMsg={this.state.successMsg}
                errorList={this.state.errorList}
                setErrorList={(errorList) => { this.setState({ errorList: errorList }) }}
                // modes
                selectedCount={this.state.selectedCount}
                createMode={this.state.createMode}
                updateMode={this.state.updateMode}
                deleteMode={this.state.deleteMode}
                submitted={this.state.submitted}
                downloadPrjFileRequested={this.state.downloadPrjFileRequested}
                // events
                onRowClick={this.onRowClick}
                onRefreshClick={this.onRefreshClick}
                onCreateClick={this.onCreateClick}
                onUpdateClick={this.onUpdateClick}
                onDeleteClick={this.onDeleteClick}
                onConfirmCreateClick={this.onConfirmCreateClick}
                onConfirmUpdateClick={this.onConfirmUpdateClick}
                onConfirmDeleteClick={this.onConfirmDeleteClick}
                onCancelClick={this.onCancelClick}
                onDownloadPrjFileClick={this.onDownloadPrjFileClick}
                // 
                projectName={this.state.projectName}
                onProjectNameChange={(event) => { this.setStateValue('projectName', event.target.value) }}
                projectNameError={this.state.projectNameError}
                setProjectNameError={(error) => { this.setStateValue('projectNameError', error) }}
                // contact attributes and methods
                firstName={this.state.firstName}
                lastName={this.state.lastName}
                onFirstNameChange={(event) => { this.setStateValue('firstName', event.target.value) }}
                onLastNameChange={(event) => { this.setStateValue('lastName', event.target.value) }}
                firstNameError={this.state.firstNameError}
                lastNameError={this.state.lastNameError}
                setFirstNameError={(error) => { this.setStateValue('firstNameError', error) }}
                setLastNameError={(error) => { this.setStateValue('lastNameError', error) }}
                // phoneNumber attributes and methods
                phoneNumber={this.state.phoneNumber}
                onPhoneNumberChange={(value) => { this.setStateValue('phoneNumber', value) }}
                phoneNumberError={this.state.phoneNumberError}
                setPhoneNumberError={(error) => { this.setStateValue('phoneNumberError', error) }}
                // email attributes and methods
                email={this.state.email}
                onEmailChange={(event) => { this.setStateValue('email', event.target.value) }}
                emailError={this.state.emailError}
                setEmailError={(error) => { this.setStateValue('emailError', error) }}
            />

        )
    }

    componentDidMount() {
        let context = this.props.context
        this.getProjects(context)
        Modal.setAppElement('body')
    }

    getProjects(context) {
        let cacheManager = new CacheManager({
            resource: `/api/accounts/${context.session.accountId}/projects`,
            cacheKey: CacheKeys.Projects(context.session.accountId),
            callback: this.getProjectsCallback,
            ttlInSecs: 600
        })
        cacheManager.getObject2(context)
    }

    getProjectsCallback = (response) => {
        response.projectList && response.projectList.forEach(project => {
            project.selected = false
        })

        let filtersStr = sessionStorage.getItem(CacheKeys.ProjectsFilter(this.props.context.session.accountId))
        let filters = filtersStr ? JSON.parse(filtersStr) : {}

        this.applyFilters(response.projectList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
        // this.setState({errorList: response.errorList, vendorList : response.vendorList})
    }

    applyFilters(projectList, searchFilter, errorList) {
        let filteredList = projectList
        if (searchFilter)
            filteredList = filteredList.filter(project => project.projectName.toLocaleLowerCase().includes(searchFilter.toLocaleLowerCase()))

        // remove checked flag from rows that are hidden
        let selectedSet = new Set()
        projectList.filter(project => project.selected).forEach(project => { selectedSet.add(project.projectId) })
        projectList.forEach(project => { project.selected = false })
        filteredList.filter(project => selectedSet.has(project.projectId)).forEach(project => { project.selected = true })

        this.setState({
            projectList: projectList,
            filteredProjectList: filteredList,
            searchFilter: searchFilter,
            selectedCount: filteredList.filter(project => project.selected).length,
            errorList: errorList
        })

        let filters = { searchFilter: searchFilter }
        sessionStorage.setItem(CacheKeys.ProjectsFilter(this.props.context.session.accountId), JSON.stringify(filters))
    }

    onRefreshClick = () => {
        let context = this.props.context
        CacheManager.removeObject(CacheKeys.Projects(context.session.accountId))
        CacheManager.removeObject(CacheKeys.Messages('pg_acc_cust', context.locale))
        this.setState({
            errorList: null,
            projectList: null,
            projectName: '',
            projectNameError: null,
            firstName: '',
            lastName: '',
            firstNameError: null,
            lastNameError: null,
            phoneNumber: null,
            phoneNumberError: null,
            email: '',
            emailError: null,
            selectedProjectId: null
        })
        this.getProjects(context);
    }

    onSearchFilterChange = (event) => {
        let searchFilter = event.target.value
        this.setState({ searchFilter: searchFilter })
        this.applyFilters(this.state.projectList, searchFilter)
    }

    onRowClick = event => {
        let projectId = event.currentTarget.getAttribute('data-row-id')
        let projectList = this.state.projectList
        projectList
            .filter(project => project.projectId === projectId)
            .forEach(project => {
                project.selected = !Boolean(project.selected)
            })

        this.setState({ projectList: projectList })
        this.applyFilters(projectList, this.state.searchFilter)
    }

    onCreateClick = () => {
        this.setState({
            createMode: true
        });
    }

    onConfirmCreateClick = () => {
        this.setStateValue('submitted', true);

        RestApiUtils.post(this.props.context,
            `/api/accounts/${this.props.context.session.accountId}/projects`,
            this.onSubmitCallback, {
            projectName: this.state.projectName,
            contactFirstName: this.state.firstName,
            contactLastName: this.state.lastName,
            contactPhone: this.state.phoneNumber,
            contactEmail: this.state.email
        });
    }

    onSubmitCallback = () => {
        this.setStateValue('submitted', false);
        this.onCancelClick();
        this.onRefreshClick();
    }

    onUpdateClick = () => {
        this.getProjectDetailsAndSetStateForUpdate();
        this.setState({
            updateMode: true
        });
    }

    getProjectDetailsAndSetStateForUpdate = () => {
        let selectedProjectDetails = this.state.projectList.find((project) => (project.selected));
        this.setState({
            selectedProjectId: selectedProjectDetails.projectId,
            projectName: selectedProjectDetails.projectName,
            firstName: selectedProjectDetails.contactFirstName,
            lastName: selectedProjectDetails.contactLastName,
            phoneNumber: selectedProjectDetails.contactPhone,
            email: selectedProjectDetails.contactEmail
        });
    }

    onConfirmUpdateClick = () => {
        this.setStateValue('submitted', true);

        RestApiUtils.put(this.props.context,
            `/api/projects/${this.state.selectedProjectId}`,
            this.onUpdateSubmitCallback, {
            projectName: this.state.projectName,
            contactFirstName: this.state.firstName,
            contactLastName: this.state.lastName,
            contactPhone: this.state.phoneNumber,
            contactEmail: this.state.email
        });
    }

    onUpdateSubmitCallback = () => {
        this.setStateValue('submitted', false);
        this.onCancelClick();
        this.onRefreshClick();
    }

    onCancelClick = () => {
        this.setState({
            createMode: false,
            updateMode: false
        });
    }

    setStateValue = (fieldName, value) => {
        this.setState({
            [fieldName]: value
        });
    }

    onDownloadPrjFileClick = (event) => {
        let context = this.props.context
        let projectId = event.currentTarget.getAttribute('data-row-id')
        this.setState({ downloadPrjFileRequested: true })
        RestApiUtils.get(this.props.context,
            `/api/accounts/${context.session.accountId}/projects/${projectId}/files/attachment/fileDownloadSignedUrl`,
            this.onDownloadPrjFileClickCallback, null, null
        )
    }

    onDownloadPrjFileClickCallback = (response) => {
        this.setState({
            downloadPrjFileErrorList: response.errorList,
            downloadPrjFileRequested: false
        })

        if (response.errorList.length === 0) {
            const link = document.createElement('a')
            link.href = response.signedUrl.signedUrl
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }

}

export default ProjectListPageSF
